import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/lib/auth';
import LoginPage from '@/pages/LoginPage';
import CalendarPage from '@/pages/CalendarPage';
import AdminPage from '@/pages/AdminPage';
import TicketsPage from '@/pages/TicketsPage';
import ReportsPage from '@/pages/ReportsPage';
import CommsPage from '@/pages/CommsPage';
import CallsPage from '@/pages/CallsPage';
import HandoffsPage from '@/pages/HandoffsPage';
import AgentChatPage from '@/pages/AgentChatPage';
import VoiceAgentPage from '@/pages/VoiceAgentPage';
import TalkPage from '@/pages/TalkPage';
import AppShell from '@/components/AppShell';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-stone-600">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Navigate to="/calendar" replace />} />
            <Route path="/calendar" element={<RequireAuth><CalendarPage /></RequireAuth>} />
            <Route path="/tickets" element={<RequireAuth><TicketsPage /></RequireAuth>} />
            <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />
            <Route path="/comms" element={<RequireAuth><CommsPage /></RequireAuth>} />
            <Route path="/calls" element={<RequireAuth><CallsPage /></RequireAuth>} />
            <Route path="/handoffs" element={<RequireAuth><HandoffsPage /></RequireAuth>} />
            <Route path="/agent" element={<RequireAuth><AgentChatPage /></RequireAuth>} />
            <Route path="/voice" element={<RequireAuth><VoiceAgentPage /></RequireAuth>} />
            <Route path="/talk/:token" element={<TalkPage />} />
            <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route path="/admin/:tab" element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route path="/assistant" element={<Navigate to="/agent" replace />} />
            <Route path="*" element={<Navigate to="/calendar" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
